<div class="replies" cdkDropList cdkDropListSortingDisabled [cdkDropListDisabled]="disableDragDrop">
    @for (
        reply of replies
            | filter: selectedActivity?.id : 'customer_projectphase_activity_id'
            | filter: null : 'parent_reply_id';
        track reply
    ) {
        <div
            class="reply"
            cdkDrag
            [class.highlight]="highlightId === reply.id"
            [cdkDragDisabled]="!(Functionalities.GeoManage | hasFunctionality) && user.id !== reply.user_id"
            [cdkDragData]="reply">
            @let documents = replies | filter: reply.id : 'parent_reply_id';
            @let isDocument = reply.is_document || documents.length;
            <div class="prefix">
                <div [class.document]="isDocument" class="icon"></div>
            </div>
            <div (click)="openReply(reply)" class="item">
                <b>{{ isDocument ? 'Document' : reply.name }}</b>
                <br />
                @if (!reply.is_document && reply.text) {
                    <div [innerHTML]="reply.text | nl2br"></div>
                    <br />
                }
                @if (reply.is_document) {
                    <div class="document-row" title="{{ reply.name }}">
                        <i class="fas fa-paperclip me-1"></i>{{ reply.name }}
                    </div>
                }
                @for (doc of documents; track doc) {
                    <div (click)="openReply(doc)" class="document-row" title="{{ doc.name }}">
                        <i class="fas fa-paperclip me-1"></i>{{ doc.name }}
                    </div>
                }
                {{ reply.user?.name }} {{ reply.updated_at | date: 'd MMMM yyyy, H:mm' }} uur
            </div>
            <div class="suffix">
                <div class="icon"></div>
                @if ((Functionalities.GeoManage | hasFunctionality) || user.id === reply.user_id) {
                    <button (click)="delete(reply)" color="warn" mat-icon-button>
                        <mat-icon class="fa fa-trash"></mat-icon>
                    </button>
                }
            </div>
        </div>
    }
    @if ([Functionalities.CustomerProjectsParticipate, Functionalities.CustomerProjectsManage] | hasFunctionality) {
        @if (stagedFiles.length) {
            <div class="mt-2">
                @for (file of stagedFiles; track file) {
                    <span class="badge bg-light text-dark me-1 mb-1 d-inline-flex align-items-center">
                        {{ file.filename }}
                        <button
                            (click)="removeStagedFile(file)"
                            aria-label="Verwijderen"
                            class="btn-close ms-1"
                            type="button"></button>
                    </span>
                }
            </div>
        }
        <mat-form-field (focusin)="inputActive = true" (focusout)="inputActive = false">
            <div matPrefix></div>
            <mat-label>
                Voeg een reactie toe
                <img src="../../../assets/images/icons/customer-projects/arrow_right.svg" />
            </mat-label>
            <textarea
                #autosize="cdkTextareaAutosize"
                #replyInput
                (keyup)="enterKey($event)"
                [formControl]="fcReplyContent"
                cdkAutosizeMaxRows="5"
                cdkAutosizeMinRows="1"
                cdkTextareaAutosize
                matInput></textarea>
            <div [class.show-save]="fcReplyContent.value || stagedFiles.length" matSuffix>
                <app-document-upload
                    (uploaded)="upload($event)"
                    [buttonIcon]="true"
                    [fileTypes]="['application/pdf', 'image/jpeg', 'image/png']"
                    [customer]="customer"
                    currentPath="{{ phase?.id }}"
                    icon="../../assets/images/icons/customer-projects/document.svg"
                    storage="projectreplies"></app-document-upload>
                @if (fcReplyContent.value || stagedFiles.length) {
                    <button (click)="save($event)" [disabled]="fcReplyContent.disabled" color="primary" mat-icon-button>
                        @if (fcReplyContent.disabled) {
                            <i class="fas fa-spinner fa-spin"></i>
                        } @else {
                            <img src="../../../assets/images/icons/customer-projects/arrow_right.svg" />
                        }
                    </button>
                }
            </div>
        </mat-form-field>
    }
</div>
